import axios from 'axios';
import appInsights from './app-insights';

const env = process.env.REACT_APP_ENV as string;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL as string;

export type FreezeState = {
  isFreezeActive: boolean;
  lastModifiedBy: string;
  lastModifiedAt: string;
};

export const getFreezeState = async (): Promise<FreezeState> => {
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `${adminApiUrl}/admin/freeze-state`,
    headers: {
      'env': `${env}`,
    },
    data: '',
  };

  try {
    var response = await axios.request(config);
    if (response.status === 200) {
      appInsights.logInfo('Successfully retrieved freeze state');
      return response.data;
    } else {
      appInsights.logError(`Unexpected status code when getting freeze state :: ${response.status} :: ${response.statusText}`);
      throw response;
    }
  } catch (err: any) {
    appInsights.logError(`Failed to retrieve freeze state :: ${err.message}`);
    throw err;
  }
};
